import { wishListCardStyles } from "@insite/content-library/Components/WishListCard";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

wishListCardStyles.actionAddToCartButton = {
    variant: "primary",
    css: css`
        white-space: nowrap;
        width: 100%;
    `, // keep text from wrapping
};

wishListCardStyles.actionDeleteButton = {
    variant: "secondary",
    css: css`
        width: 100%;
        margin-top: 10px;
    `,
};
wishListCardStyles.detailLinkGridItem = {
    width: 12,
    css: css`
        a {
            span {
                color: ${getColor("text.link")} !important;
                font-size: ${TYPOGRAPHY.size.large};
                font-weight: ${TYPOGRAPHY.weight.mediumbold};
                //text-transform: uppercase;
                &:hover {
                    color: ${getColor("text.link")} !important;
                    text-decoration-line: underline;
                }
            }
        }
    `,
};
wishListCardStyles.gridContainer = {
    gap: 5,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        margin-bottom: 15px;
                    `,
                    css`
                        margin-bottom: 15px;
                    `,
                    css`
                        margin-bottom: 15px;
                    `,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};

wishListCardStyles.actionGridItem = {
    width: [2, 2, 4, 4, 2],
    align: "top",
    css: css`
        justify-content: flex-end;
    `,
};

wishListCardStyles.wishListInfoGridItem = {
    width: [10, 10, 8, 8, 10],
    align: "middle",
};
